import React, { useState, useEffect } from 'react';
import client from "../../services/Api";
import { useParams } from 'react-router-dom'
import moment from 'moment';
import DataTable from 'react-data-table-component';

function DeviceLog({ location, history, params }) {
    const [logs, setLogs] = useState([])
    const { mac } = useParams();


    //datatable config
    const columns = [
        {
            name: 'Data/Hora',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: true,
            width: '13%'
        },
        {
            name: 'Tipo do evento',
            selector: 'type_formatted',
            sortable: true,
            width: '10%'
        },
        {
            name: 'Mensagem',
            selector: 'message',
            sortable: true,
            width: '50%'
        },
        {
            name: 'Responsável',
            selector: 'name',
            format: row => row.user.name,
            sortable: true,
            width: '10%'
        },
        {
            name: 'Cliente',
            format: row => row.client?.toUpperCase(),
            selector: 'client',
            sortable: true,
        },
        {
            name: 'Versão do cliente',
            selector: 'clientVersion',
            sortable: true,
        },
        {
            name: 'Versão do S.O',
            selector: 'clientOs',
            format: row => row.clientOs?.toUpperCase(),
            sortable: true,
        },
        {
            name: 'Versão da API',
            selector: 'apiVersion',
        },

    ];

    useEffect(() => {
        getBeaconHistory()
    }, []);

    async function getBeaconHistory() {
        try {
            const response = await client.get(`/api/beacon-device/${mac}/logs`);
            setLogs(response.data.content)
            return response;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <div className="beacon-table">
            <DataTable
                columns={columns}
                data={logs}
                noDataComponent={
                    <span>Nada encontrado.</span>
                }
                pagination={true}
            />
        </div>
    );

}

export default DeviceLog;